const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/view-all.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import PostCard, { postCardRIVProps } from '@/Components/posts/ui/posts-card';
import RenderIfVisible from '@/Utility/RenderIfVisible';
import { ZnglyVideosFrontendQuery, type ZnglyVideos_Frontend_Pagination_Fragment$key, type ZnglyVideos_Frontend_Query } from '@/graphql/queries/ZnglyVideo.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { usePaginationFragment } from '@/graphql/relay.utils';
import type { ZnglyVideo } from '@/graphql/types';
import { useAppStore } from '@/inertia/AppStore';
import Page from '@/inertia/Shared/Page';
import { Grid } from '@mui/material';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useMemo } from 'react';
import { loadQuery } from 'react-relay';
import { toast } from 'react-toastify';
type Props = {
  isFallback?: boolean;
} & Partial<ReturnType<typeof usePaginationFragment<ZnglyVideos_Frontend_Query, ZnglyVideos_Frontend_Pagination_Fragment$key>>>;
const ViewAll = (props: Props) => {
  const setShowFooter = useAppStore(state => state.setShowFooter);
  const setIsPageLoading = useAppStore(state => state.setIsPageLoading);
  const navigate = useNavigate();
  useEffect(() => {
    setShowFooter(false);
    return () => {
      setShowFooter(true);
    };
  }, []);
  useEffect(() => {
    // if we are at the end of the list, show the footer
    if (!props?.data?.znglyVideos?.edges?.length && !props?.isFallback && !props?.isLoadingNext && !props?.isRefetching && props?.hasNext === false) {
      setShowFooter(true);
    }
  }, [props?.data?.znglyVideos?.edges?.length, props?.isFallback, props?.hasNext, props?.isLoadingNext, props?.isRefetching]);
  const data = useMemo(() => {
    if (props?.isFallback) return [];
    if (!props?.data?.znglyVideos?.edges) return [];
    return props?.data?.znglyVideos?.edges;
  }, [props?.data?.znglyVideos?.edges, props?.isFallback]);
  const loadMore = () => {
    if (!props?.hasNext) return;
    if (props?.isLoadingNext || props?.isRefetching) return;
    setIsPageLoading(true);
    props?.loadNext?.(12, {
      onComplete: error => {
        setIsPageLoading(false);
        if (!!error) {
          toast.error(error?.message);
        }
      }
    });
  };
  return <Page>
      <Grid container sx={{
      mt: 2,
      mb: 2
    }}>
        {data?.map(({
        node
      }, idx) => {
        return <RenderIfVisible key={`gridview_${node?.id ?? idx}`} {...postCardRIVProps(node as ZnglyVideo, 'catalog', idx)} onChange={isVisible => {
          if (isVisible && idx === data?.length - 1) loadMore();
        }}>
              <PostCard fallback={props?.isFallback} key={node?.id} type="catalog" node={node as ZnglyVideo} showHref onClick={node => {
            if (!node?.id) return;
            navigate({
              to: '/content/$postId',
              params: {
                postId: node.id
              }
            });
          }} />
            </RenderIfVisible>;
      })}
      </Grid>
    </Page>;
};
export const Route = createFileRoute('/view-all')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  loader: () => {
    return loadQuery<ZnglyVideos_Frontend_Query>(RelayEnvironment, ZnglyVideosFrontendQuery, {}, {
      fetchPolicy: 'store-or-network'
    });
  },
  pendingComponent: () => <ViewAll isFallback />,
  onEnter: () => {
    useAppStore.getState().resetInertia();
    useAppStore.getState().setPageType('view-all');
  }
});